import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getInternalPortalAnnouncements } from "../api/api";
import LayoutBottom from "../Components/Layout/LayoutBottom";
import LayoutTop from "../Components/Layout/LayoutTop";

import AnnouncementSliderComponent from "../Components/Sliders/AnnouncementSliderComponent";
import PdfEmbed from "./PdfEmbed";


function  StructurePagePage() {

  const { t, i18n } = useTranslation();







  return (
    <>
    <LayoutTop/>
    <div className="wrapper3 wrapper4">
            <div className="container-fluid">
                <h4 className="shape-round mb-lg-5 pb-5">الهيكل التنظيمي</h4>
                <PdfEmbed
        embedURL="https://s3.tatweertransit.com/upload/structure.pdf"
      />
                
            </div>
        </div>
        <LayoutBottom/>

    </>
  );
}

export default  StructurePagePage;
